(function () {
  function wrapOf(el) {
    return el.closest('.field, .form__field, .mp-field, .customer__field, p') || el.parentElement;
  }

  function messageFor(el) {
    var v = el.validity;
    if (v.valueMissing) return 'Vul dit veld in.';
    if (v.typeMismatch) {
      if (el.type === 'email') return 'Vul een geldig e-mailadres in.';
      if (el.type === 'url') return 'Vul een geldige URL in.';
      return 'Vul een geldige waarde in.';
    }
    if (v.tooShort || v.tooLong) return 'Controleer de lengte van dit veld.';
    if (v.patternMismatch) return 'De invoer heeft niet het juiste formaat.';
    if (v.rangeUnderflow || v.rangeOverflow || v.stepMismatch) return 'De waarde valt buiten het toegestane bereik.';
    return 'Controleer dit veld.';
  }

  function existingMessage(wrap) {
    var next = wrap.nextElementSibling;
    return next && next.classList && next.classList.contains('mp-field-message') ? next : null;
  }

  function messageSlot(wrap) {
    var slot = existingMessage(wrap);
    if (!slot) {
      slot = document.createElement('span');
      slot.className = 'mp-field-message';
      slot.setAttribute('aria-live', 'polite');
      wrap.parentNode.insertBefore(slot, wrap.nextSibling);
    }
    return slot;
  }

  function mark(el, invalid) {
    var wrap = wrapOf(el);
    el.classList.toggle('mp-invalid', invalid);
    if (!wrap) return;
    wrap.classList.toggle('mp-invalid', invalid);
    if (invalid) {
      messageSlot(wrap).textContent = messageFor(el);
      el.setAttribute('aria-invalid', 'true');
    } else {
      var slot = existingMessage(wrap);
      if (slot) slot.remove();
      el.removeAttribute('aria-invalid');
    }
  }

  function fields(form) {
    return [].slice.call(form.querySelectorAll('input, textarea, select')).filter(function (el) {
      return el.willValidate && el.type !== 'hidden';
    });
  }

  function isField(el) {
    return el && el.willValidate && el.matches && el.matches('input, textarea, select');
  }

  function bind(form) {
    if (form.__mpForms) return;
    form.__mpForms = true;
    form.setAttribute('novalidate', 'novalidate');

    // Submit is the only moment every field is judged, touched or not.
    form.addEventListener('submit', function (e) {
      var first = null;
      fields(form).forEach(function (el) {
        el.__mpTouched = true;
        var ok = el.checkValidity();
        mark(el, !ok);
        if (!ok && !first) first = el;
      });
      if (first) {
        e.preventDefault();
        first.focus();
      }
    });

    // A field the visitor never typed in must never be scolded on the way out.
    // Autofocused dialogs blur an empty required field the moment you click the
    // overlay, which is what used to make the welcome popup complain about an
    // e-mail address nobody had started typing yet.
    form.addEventListener(
      'blur',
      function (e) {
        var el = e.target;
        if (!isField(el)) return;
        if (!el.__mpTouched && el.value === '') {
          mark(el, false);
          return;
        }
        mark(el, !el.checkValidity());
      },
      true
    );

    // Focusing an empty field clears a leftover message, so a dialog that is
    // closed mid-typing and opened again does not reopen on its own error.
    form.addEventListener(
      'focus',
      function (e) {
        var el = e.target;
        if (!isField(el)) return;
        if (el.value === '') mark(el, false);
      },
      true
    );

    function touched(e) {
      var el = e.target;
      if (!isField(el)) return;
      el.__mpTouched = true;
      if (el.classList.contains('mp-invalid') && el.checkValidity()) mark(el, false);
    }

    form.addEventListener('input', touched, true);
    form.addEventListener('change', touched, true);
  }

  function init() {
    [].slice.call(document.querySelectorAll('form')).forEach(bind);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
